import { render } from "./OcrHelpModal.vue?vue&type=template&id=4f6dca1f&scoped=true"
import script from "./OcrHelpModal.vue?vue&type=script&lang=js"
export * from "./OcrHelpModal.vue?vue&type=script&lang=js"

import "@/assets/css/components/OcrHelpModal.scss?vue&type=style&index=0&id=4f6dca1f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6dca1f"]])

export default __exports__